// Show/hide the `.scroll-top-button` based on scroll position, and smooth-scroll
// to the top on click (honouring prefers-reduced-motion per WCAG 2.3.3).

const scrollBtn = document.querySelector('.scroll-top-button');

if (scrollBtn) {
  window.addEventListener(
    'scroll',
    () => {
      scrollBtn.style.display = window.scrollY > 200 ? 'block' : 'none';
    },
    { passive: true }
  );

  const scrollLink = scrollBtn.querySelector('.scroll-top');

  if (scrollLink) {
    scrollLink.addEventListener('click', () => {
      const prefersReduce =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({
        top: 0,
        behavior: prefersReduce ? 'auto' : 'smooth',
      });
    });
  }
}
